import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../share/service/auth.service";

@Component({
	selector: "app-forgot-password",
	templateUrl: "./forgot-password.component.html",
})
export class ForgotPasswordComponent implements OnInit {
	success: boolean;
	formGroup: UntypedFormGroup;

	constructor(authService: AuthService) {
		if (authService.isLoggedIn()) {
			location.href = "/dashboard";
		}
	}

	ngOnInit(): void {
		this.formGroup = new UntypedFormGroup({
			userName: new UntypedFormControl(null, [Validators.required]),
		});
	}

	reset() {
		this.success = true;
	}
}
